export const images = {
  trampoline: require('../../assets/images/Cama elastica.jpg'),
  homeBackground: require('../../assets/images/homeBack.jpeg'),
  birthdayInfo: require('../../assets/images/informacion_cumpleanos.jpg'),
  logo: require('../../assets/images/logo.png'),
  map: require('../../assets/images/map.png'),
  birthdayRules: require('../../assets/images/normativa_cumpleanos.jpg'),
  facilities: require('../../assets/images/nuestro_instalaciones.png'),
  generalPrice: require('../../assets/images/precio.png'),
  birthdayPriceMain: require('../../assets/images/precio_cumple.jpg'),
  combatBridge: require('../../assets/images/puente_combate.jpg'),
  bridge: require('../../assets/images/puente.jpg'),
  basketballZone: require('../../assets/images/zona_baloncesto.jpg'),
  kidsZone: require('../../assets/images/zona_infantil.jpg'),
  jumpingZone: require('../../assets/images/zona_jumping.jpg'),
  youthZone: require('../../assets/images/zona_juvenil.jpg'),
};
